export const environment = {
  production: true,
  DEV: {
    // BASE_URL: 'http://54.67.117.105:8000/api/v1',
    BASE_URL: 'https://api.befulfilled.io/api/v1',
    TEST_URL: 'http://54.67.117.105:8000',
  },
};
